import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import ChevronRight from '@pedidosya/web-fenix/icons/ChevronRight';
import { COLOR, SIZE, FONTS_MAP } from './constants';

const StyledButton = styled.button`
  height: auto;
  position: relative;
  background-position: center;
  transition: background-color 0.8s;
  border-radius: ${({ color, theme }) =>
    theme.commons.button[color].borderRadius};
  align-self: flex-start;

  /* pressed state */
  &:active {
    background: ${({ color, theme }) =>
      theme.commons.button[color].backgroundPressed};
    background-size: 100%;
    transition: background 0s;
  }

  /* color */
  ${({ color, theme }) => css`
    background: ${theme.commons.button[color].background};
    color: ${theme.commons.button[color].color};
  `}

  /* size */
  ${({ size, theme }) => css`
    width: ${theme.commons.button.sizes[size].width};
    padding: ${theme.commons.button.sizes[size].padding};
    line-height: ${theme.commons.button.sizes[size].lineHeight};
    ${theme.fontFamily.mainFont[FONTS_MAP[size]]}
  `}

  /* disabled */
  ${({ theme, color, disabled }) =>
    disabled &&
    css`
      opacity: ${theme.commons.button[color].opacity};
      background: ${theme.commons.button[color].background};
    `}

  /* active */
  ${({ theme, active, color }) =>
    active &&
    css`
      background: ${theme.commons.button[color].backgroundActive};
      color: ${theme.commons.button[color].colorActive};
    `}
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-items: center;
`;

const SimpleButton = React.forwardRef(
  (
    {
      elementId,
      onClick,
      className,
      disabled,
      type,
      label,
      color,
      icon,
      size,
      active,
      isAction,
    },
    ref,
  ) => {
    const props = {
      onClick,
      disabled,
      type,
      className,
      id: elementId,
      color,
      size,
      active,
    };

    return (
      <StyledButton ref={ref} {...props}>
        {icon || isAction ? (
          <StyledBody>
            {icon}
            <span>{label}</span>
            {isAction && <ChevronRight ariaHidden size="small" />}
          </StyledBody>
        ) : (
          label
        )}
      </StyledButton>
    );
  },
);

SimpleButton.propTypes = {
  elementId: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(Object.values(COLOR)),
  size: PropTypes.oneOf(Object.values(SIZE)),
  icon: PropTypes.node,
  active: PropTypes.bool,
  isAction: PropTypes.bool,
};

SimpleButton.defaultProps = {
  disabled: false,
  type: 'button',
  color: COLOR.SECONDARY,
  size: SIZE.FULL,
  active: false,
  isAction: false,
};

SimpleButton.displayName = 'SimpleButton';

export default SimpleButton;
